export default __webpack_public_path__ + "static/media/add-icon.df35a134.svg";